import { PORTAL_INSTANCE_FAVICAR } from '@src/constants'
import { environment } from '@src/utils/environment'
import { useMemo } from 'react'

export const useAppInstance = () => {
    const isFavicar = useMemo(() => environment.API_ROOT.includes(PORTAL_INSTANCE_FAVICAR), [])

    return isFavicar
}
